import styled from "styled-components";

export const ContainerInputSignInPage = styled.div`
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 20px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  position: relative;

  transition: 150ms cubic-bezier(0.61, 0, 0.51, 1);

  &.error-animation-input {
    border: 3px solid #e63946;
    border-radius: 20px;
  }
`;
